<template>
 <div>
  <div class="detailsTitle" >
    <h4>新增</h4>
    <div @click="back"><i class="fa fa-reply"></i></div>
  </div>
  <div>
     <el-form  :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline" label-width="130px" size="mini">
        <div class="inpBox jiaoyan">
             <el-form-item label="船舶名称:" prop="shipName">
                <el-select  v-model="addFrom.shipName"   placeholder="请选择" filterable>
                  <el-option v-for="item in CBList" :label="item.shipName" :value="item.shipName" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="航次号:" prop="voyageNo">
              <el-input placeholder="" maxlength="10"  v-model="addFrom.voyageNo"></el-input>
            </el-form-item>
            <el-form-item label="起始港口:" prop="deliverAddressId" class="jiage">
              <el-select v-model="addFrom.deliverAddressId" placeholder="请选择" filterable @change="qishiChange">
                <el-option v-for="(item) in MTList" :label="item.addressName" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="目的港口:" prop="receivingAddressId" class="jiage">
              <el-select v-model="addFrom.receivingAddressId" placeholder="请选择" filterable @change="qishiChange">
                <el-option v-for="(item) in MTList" :label="item.addressName" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="上传明细:" prop="" class="jiage" v-if="!id">
              <div style="width:300px">
                <el-upload
                  action=""
                  :auto-upload=false
                  :multiple=true
                  :file-list="filelist"
                  :on-change="imgPreview"
                  accept=".xls,.csv,.xlsx"
                  :limit="1"
                  :on-remove="handleRemove" :class="[fileIsAdd?'hidden':'']">
                  <i class="fa fa-upload" aria-hidden="true" ></i>
                </el-upload>
              </div>
            </el-form-item>

        </div>
      </el-form>
      <div class="footerBtn">
        <el-button  class="bigBtn"    @click="back">返回</el-button>
        <el-button type="primary" class="bigBtn"    @click="saveFn">保存</el-button>
      </div>
  </div>
 </div>
</template>

<script>
import { addShipInkjetTask, sAddressList, getShipIdAndNameList, upShipInkjetTask, shipInkjetTaskDetail } from '@/api/shipping'
export default {
  data () {
    let id = this.$route.query.id
    return {
      addFrom: {},
      rules: {
        shipName: [
          { required: true, message: '请选择船舶名称', trigger: 'blur' }
        ],
        voyageNo: [
          { required: true, message: '请输入航次号', trigger: 'blur' }
        ]

      },
      id: id,
      MTList: [],
      CBList: [], // 船舶
      fileIsAdd: false,
      filelist: []
    }
  },
  created () {
    sAddressList({ addressType: 2 }).then(res => {
      this.MTList = res
    })
    getShipIdAndNameList().then(res => {
      this.CBList = res
    })
    if (this.id) {
      shipInkjetTaskDetail({ id: this.id }).then(res => {
        this.addFrom = res
        // this.$set(this.addFrom, 'deliverAddressId', Number(res.deliverAddressId))
        // this.$set(this.addFrom, 'receivingAddressId', Number(res.receivingAddressId))
      })
    }
  },
  mounted () {

  },
  methods: {
    // 文件上传
    handleRemove (file, fileList) {
      this.filelist = fileList
      if (fileList.length < 1) {
        this.fileIsAdd = false
      }
      if (this.addFrom.fileUrl) {
        this.addFrom.fileUrl = ''
      }
    },
    imgPreview (file, fileList) {
      this.filelist = fileList
      let fileName = file.name
      var regex = /(?:xlsx|csv|xls)$/
      if (regex.test(fileName.toLowerCase())) {
        if (fileList.length == 1) {
          this.fileIsAdd = true
        } else {
          this.fileIsAdd = false
        }
      } else {
        fileList.pop()
        this.$alert('不支持此类型', '系统提示')
        return false
      }
    },
    saveFn () {
      this.$refs.addFrom.validate((valid) => {
        if (valid) {
          if (this.addFrom.deliverAddressId) {
            let json = this.MTList.find(item1 => item1.id == this.addFrom.deliverAddressId)
            this.addFrom.deliverAddressName = json.addressName
          }
          if (this.addFrom.receivingAddressId) {
            let json = this.MTList.find(item1 => item1.id == this.addFrom.receivingAddressId)
            this.addFrom.receivingAddressName = json.addressName
          }
          if (this.id) { // 修改
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            upShipInkjetTask(this.addFrom).then(res => {
              loading.close()
              this.$message({
                message: '操作成功',
                type: 'success'
              })
              this.$router.go(-1)// 返回上一层
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else { // 新增
            let formData = new FormData()
            if (this.filelist.length == 1 && !this.filelist[0].flag) {
              formData.append('file', this.filelist[0].raw)
            }
            formData.set('params', JSON.stringify(this.addFrom))
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            addShipInkjetTask(formData).then(res => {
              loading.close()
              this.$message({
                message: '操作成功',
                type: 'success'
              })
              this.$router.go(-1)// 返回上一层
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }
        }
      })
    },
    // 起始港改变
    qishiChange (e) {
      if (this.addFrom.receivingAddressId == this.addFrom.deliverAddressId) {
        this.$alert('起始港口与目的港口不能相同', '系统提示')
        this.$set(this.addFrom, 'deliverAddressId', null)
      }
    },
    // 目的港改变
    mudiChange (e, index) {
      if (this.addFrom.receivingAddressId == this.addFrom.deliverAddressId) {
        this.$alert('起始港口与目的港口不能相同', '系统提示')
        this.$set(this.addFrom, 'receivingAddressId', null)
      }
    },
    daoruFN () {
      this.daoruMark = true
    },
    destroy () {
      this.daoruMark = false
    },
    back () {
      this.$router.go(-1)// 返回上一层
    }
  }
}
</script>

<style scoped lang='less'>
/deep/.el-upload--text{
   width: 180px;
    height: 180px;
    border: 1px #C0C4CC solid;
    border-radius: 4px;
}
/deep/.el-upload--text i{
   font-size: 60px;
  color: #606266;
  margin-top: 50px;
}
.hidden /deep/.el-upload--text{
  display: none;
}
.inpBox /deep/.el-input__inner {
    width: 180px;
}
</style>
